import { PaginationProps } from '@mantine/core';

import { Select } from '../../../Combobox/Select/Select';
import { Group } from '../../../Layout/Group';
import { Pagination } from '../../../Navigation/Pagination/Pagination';

interface SearchPaginationProps extends PaginationProps {
  isTotalUnknown?: boolean;
}
interface PaginationSelectProps {
  value?: string;
  defaultValue?: string | null | undefined;
  onChange: (value: number) => void;
}
interface PaginationForSearch {
  paginationProps: SearchPaginationProps;
  selectProps: PaginationSelectProps;
}

const PaginationForSearch = ({
  selectProps,
  paginationProps: { isTotalUnknown, onChange, ...paginationProps },
}: PaginationForSearch) => {
  return (
    <Group justify="space-between">
      <Select.Pagination
        defaultValue={selectProps.defaultValue}
        onChange={(value) => {
          selectProps.onChange(Number(value));
        }}
        allowDeselect={false}
      />
      <Pagination
        value={paginationProps.value}
        onChange={(number) => {
          if (onChange) {
            onChange(number);
          }
        }}
        total={paginationProps.total}
        // When we have a deliberately set unknown page count, we need to set the boundaries and siblings to 0 so that the pagination doesn't show
        boundaries={isTotalUnknown ? 0 : undefined}
        siblings={isTotalUnknown ? 0 : undefined}
      />
    </Group>
  );
};

export { PaginationForSearch };
